/* global VERSION, REQUEST_TIMEOUT, REQUEST_TIMEOUT_HUGE */
import config from 'config';
import getObjectProperty from 'get-object-property';
import logger from 'utils/Logger';
import loggerTemplates from 'utils/Logger/templates';
import request from 'superagent';
import requestPrefix from 'superagent-prefix';
import urlParse from 'url-parse';

const url = urlParse(global.window.location.href);

// NOTE: protocol is not allowed to change
// check if config.api hostname or port is not empty
if (config.api.hostname) {
  url.set('hostname', config.api.hostname);
}
if (config.api.port) {
  url.set('port', config.api.port);
}
if (config.api.pathname) {
  url.set('pathname', config.api.pathname);
}
// clean up query string and # just in case
url.set('query', '');
url.set('hash', '');
export const prefixString = url.href.slice(-1) === '/' ? url.href.slice(0, -1) : url.href;

// prefix - is a function that generates this prefix: https://mysparcit.com/api/subdomain-code/
export const prefix = requestPrefix(prefixString);

export const reqToJSON = req => ({
  url: req.url,
  method: req.method,
  header: req.header,
  GET: req.GET,
  POST: req.POST,
  body: req.body,
});

const warningTypes = {
  EmptyValue: 'EmptyValue',
  TooSoon: 'TooSoon',
  ValueTooLong: 'ValueTooLong',
  ValueTooShort: 'ValueTooShort',
  NotEnoughAnswers: 'NotEnoughAnswers',
  InvalidAnswers: 'InvalidAnswers',
  VertexNotFound: 'VertexNotFound',
  InvalidEmail: 'InvalidEmail',
};

// Used when request terminated and response is empty
export const mockRes = (req, msg = 'Error while connecting to the server. Please try again.') => ({
  ok: false,
  type: null,
  body: { status: 0, error: msg, message: msg },
  headers: {},
  req: req,
});

// Wrap superagent request, so that it is easy to commit actions from controller
export default function commitActionFactory(processType, sessionId) {
  return (action, payload, context, cb) => {
    const { addRequest, controllerId, store } = context;
    const requestId = Math.random()
      .toString(36)
      .substr(2, 24);
    const req = request
      .post(`/session/${processType.toUpperCase()}/${action}`)
      .send(payload, context, cb)
      .use(prefix)
      .set('XIT-Session-Id', sessionId)
      .set('XIT-Request-Id', requestId)
      .set('XIT-Client-Version', VERSION)
      .withCredentials();
    // register with Controller
    const removeRequest = addRequest(req);
    const timeoutId = global.window.setTimeout(() => {
      logger.warn(`Request takes more than ${REQUEST_TIMEOUT} ms`, {
        state: store.state,
        req: reqToJSON(req),
      });
    }, REQUEST_TIMEOUT);
    const timeoutIdHuge = global.window.setTimeout(() => {
      logger.error(`Request takes more than ${REQUEST_TIMEOUT_HUGE} ms`, {
        state: store.state,
        req: reqToJSON(req),
      });
    }, REQUEST_TIMEOUT_HUGE);
    req.end((err, res) => {
      global.window.clearTimeout(timeoutId);
      global.window.clearTimeout(timeoutIdHuge);
      removeRequest();
      if (!err) {
        // log success
        logger.info(loggerTemplates.action(action, controllerId));
      } else if (res && warningTypes[res.body.type]) {
        logger.warn(loggerTemplates.error(res), {
          state: store.state,
          req: reqToJSON(getObjectProperty(() => res.req), {}, false),
          res,
        });
      } else if (res && res.body && res.body.type) {
        logger.error(loggerTemplates.error(res), {
          state: store.state,
          req: reqToJSON(getObjectProperty(() => res.req), {}, false),
          res,
        });
      } else {
        logger.error(err, { state: store.state, req: reqToJSON(req), res });
      }
      if (!res) {
        res = mockRes(req);
      }
      // pass err and res to callback
      try {
        cb(err, res);
      } catch (cbErr) {
        logger.error(cbErr, { state: store.state, req: reqToJSON(req), res });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/controllers/Session/commitActionFactory.js